import WorkGrid from '~/components/gallery/WorkGrid'
import ProjectModal from '~/components/gallery/ProjectModal'
import MainPage from './projects/templates/MainPageTemplate'

// Single component behind both /work and /work/:slug. The grid is always mounted; the
// modal overlay is toggled purely by the presence of the `slug` route param, so
// navigating in/out never unmounts the grid and deep links open straight to a project.
export default function WorkPage({ slug }: { slug?: string }) {
	return (
		<MainPage>
			<div className="h-full overflow-y-auto py-2">
				<WorkGrid />
			</div>
			{slug && <ProjectModal slug={slug} />}
		</MainPage>
	)
}

WorkPage.defaultProps = {
	slug: undefined,
}
